<div class="flex flex-col">
  <h2 class="center-text">Venues Low on Scratch Paper</h2>
    <div class="flex w-100 justify-start">

        <div class="flex items-center">
            <label class="label">Weeks Threshold</label>
            <input type="number" [(ngModel)]="weeksThreshold" min="1" max="100" class="input-field ml-10" />
            <button (click)="fetchVenuesLowScratchPaper()" class="plain-button ml-10">Submit</button>
        </div>

    </div>

    <table class="reports-table">
        <caption>
          Click on any Paper Left value to update it
        </caption>
        <thead>
            <tr>
                <th>Venue</th>
                <th>Paper Left</th>
                <th>Avg. Teams</th>
                <th>Weeks Remaining</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let venue of venuesLowScratchPaper; let i = index; else noRecord">
              <td>{{ venue.name }}</td>
              <td>
                <div class="flex align-center paperleft-value" *ngIf="!venue.editing">
                  <span (click)="startEdit(i)">{{ venue.paper_left }}</span>
                </div>
                <div class="flex align-center" *ngIf="venue.editing">
                  <input type="number" [(ngModel)]="venue.editedPaperLeft" min="1" max="1000" class="input-field"
                    [disabled]="venue.updating" />
                  <button (click)="saveEdit(i)" class="btn-success" style="margin-right: 5px;" [disabled]="venue.updating">
                    <span *ngIf="!venue.updating">&#10003;</span>
                    <span *ngIf="venue.updating">⟳</span>
                  </button>
                  <button (click)="cancelEdit(i)" class="btn-cancel" [disabled]="venue.updating">&#x2715;</button>
                  <span *ngIf="venue.updating" class="updating-text"
                    style="margin-left: 8px; font-size: 12px; color: #666;">Updating...</span>
                </div>
              </td>
              <td>{{ venue.avg_teams }}</td>
              <td>{{ venue.weeks_remaining }}</td>
            </tr>
        </tbody>
    </table>

    <p class="center-text xl-mt" *ngIf="fetching">Generating Report...</p>

</div>

<ng-template #noRecord>
    <tr>
        <td colspan="4" class="center-text">No Record Found</td>
    </tr>
</ng-template>
